import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import ActionLink from 'components/buttons/action-link/ActionLink';
import { ModalFrameFooter, ModalFrameInner } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import type { InfluencerProfile, Organization } from 'types';

applyTranslations(require('./lightweight-profile-modal.json'));

type StateProps = {
  lightweightProfile: InfluencerProfile,
  myCreatedProfileSmartlistId: number | undefined | null,
  currentOrganization: Organization
};

type OwnProps = {
  onNextButtonClick: () => void,
  onAddAnotherPost?: () => void
};

type Props = StateProps & OwnProps;

class LightweightProfileCard extends React.Component<Props> {
  render(): React.ReactNode {
    const { currentOrganization, myCreatedProfileSmartlistId, lightweightProfile, onNextButtonClick, onAddAnotherPost } = this.props;
    const profileLink = `/content-creator/profiles/${lightweightProfile.id}`;
    const isPostAdded = !!onAddAnotherPost;

    const url = myCreatedProfileSmartlistId && `/collections/creators/${myCreatedProfileSmartlistId}?orgId=${currentOrganization.id}`;
    const descriptionKey = myCreatedProfileSmartlistId ?
      'lightweight_profile_card.description_with_smartlist' :
      'lightweight_profile_card.description';

    return (
      <section className="lightweight-profile-card">
        <ModalFrameInner
          minHeight={350}
          align="center"
          verticalAlign="center"
        >
          <div className="lightweight-profile-card__icon" />
          <div className="lightweight-profile-card__subtitle">
            {isPostAdded ? __t('lightweight_profile_card.post_subtitle') : __t('lightweight_profile_card.subtitle')}
          </div>
          <div className="lightweight-profile-card__channel_container">
            <ActionLink
              link={profileLink}
              openInNewTab
              size="medium"
              decoration="none"
            >
              {`@${String(lightweightProfile.name)}`}
            </ActionLink>
            <div>
              {__t('lightweight_profile_card.added_to_collabary')}
            </div>
          </div>
          <div
            className="lightweight-profile-card__description"
            dangerouslySetInnerHTML={{
              __html: sanitizeGenericHtml(__t(descriptionKey, { url }))
            }}
          />
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton
            link={profileLink}
            newTab
            color="tertiary"
          >
            {__t('lightweight_profile_card.actions.go_to_profile')}
          </ActionButton>
          {
            !isPostAdded ? (
              <ActionButton
                onClick={onNextButtonClick}
              >
                {__t('lightweight_profile_card.actions.add_profile')}
              </ActionButton>
            ) : (
              <ActionButton
                onClick={onAddAnotherPost}
              >
                {__t('lightweight_profile_card.actions.add_post')}
              </ActionButton>
            )
          }
        </ModalFrameFooter>
      </section>
    );
  }
}

const mapStateToProps = ({ lists, lightweightProfile, organizations }): StateProps => ({
  lightweightProfile: lightweightProfile.profile,
  currentOrganization: organizations.currentOrganization,
  myCreatedProfileSmartlistId: lists.myCreatedProfileSmartlistId
});

export default connect(mapStateToProps)(LightweightProfileCard);
